export class BackendEventLogs{

  SuccessfulLogin: EventLogObject = {
    E2EProcessCode : 'EA03',
    EventCode : 'L2_EA03_USERLOGIN',
    ProcessExecutorTypeCode: 'CLI'
  };
  NegativeAdviceEvent: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_C04_NEGADVICE',
    ProcessExecutorTypeCode: 'CLI'
  };
  RecommendedFormulaEvent: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_C04_PRODADVICE',
    ProcessExecutorTypeCode: 'CLI'
  };
  EsignConfirmationEvent: EventLogObject = {
    E2EProcessCode : 'ES02',
    EventCode : 'L2_ES02_CONTRACTSIGNED',
    ProcessExecutorTypeCode: 'CLI'
  };
  SelectYongoProductEvent: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_C04_PRODSELECTED',
    ProcessExecutorTypeCode: 'CLI'
  };
  DefineAmountEvent: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_C04_PARENTINFORMEDNOTRANSFER',
    ProcessExecutorTypeCode: 'CLI'
  };
  InvalidAge: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_C04_BLKUSRAGENOK',
    ProcessExecutorTypeCode: 'CLI'
  };
  NotBelgianResident: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_C04_BLKUSRRESIDENTNOK',
    ProcessExecutorTypeCode: 'CLI'
  };
  NissExpiryMissing: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_ C04_BLKUSRNISSEXPDATEPRESNOK',
    ProcessExecutorTypeCode: 'CLI'
  };
  NissExpired: EventLogObject = {
    E2EProcessCode : 'C04',
    EventCode : 'L1_ C04_BLKUSRNISSEXPDATENOK',
    ProcessExecutorTypeCode: 'CLI'
  };

}

export enum BeEvents{
  Login = 1,
  NegativeAdvice,
  ProductRecommendation,
  EsignConfirmation,
  SelectYongoProduct,
  DefineAmount,
  InvalidAge,
  NotBelgianResident,
  NissExpired,
  NissExpiryMissing
}

export interface EventLogObject{
  E2EProcessCode : string;
  EventCode: string;
  ProcessExecutorTypeCode: string;
}

export interface EventLogViewModel extends EventLogObject{
  PartnerCode?: number;
  QuoteDetailId?: number;
  PersonId?: number;
  Uci?: string;
}